import * as React from 'react';
import { ICalculatorFieldProps } from './CalculatorField.properties';
import CalculatorDialog from './CalculatorDialog';
import { withStyles } from '@material-ui/core';
import styles from './CalculatorField.styles';
import ExtendedTextFieldContainer from 'components/ExtendedTextFieldContainer';

const CalculatorField = (props: ICalculatorFieldProps) => {
    const { classes, value, calculator, onChange, initialValues, valuesSchema, formSchema, summaryTableSchema, summaryTableData, onCalculate, isCalculateDisabled, dialogTitle, dialogStyles, onCalculatorDialogOpen, onCalculatorDialogClose, ...rest } = props;
    const [calculatorDialogOpen, setCalculatorDialogOpen] = React.useState(false);

    const [fieldValue, setFieldValue] = React.useState(value);

    React.useEffect(
        () => {
            setFieldValue(value);
        },
        [value]);

    const onOpenCalculatorDialog = (): void => {
        if (onCalculatorDialogOpen) {
            onCalculatorDialogOpen(fieldValue);
        }
        setCalculatorDialogOpen(true);
    };

    const onCloseCalculatorDialog = (): void => {
        setCalculatorDialogOpen(false);
        if (onCalculatorDialogClose) {
            onCalculatorDialogClose();
        }
    };

    const handleOk = (val?: any): void => {
        onChange(val);
        onCloseCalculatorDialog();
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue(event.target.value);
    };

    const handleBlur = () => {
        onChange({ fieldValue });
    };

    return (
        <>
            <div className={classes.extendedFieldCnt}>
                <ExtendedTextFieldContainer
                    {...rest}
                    value={fieldValue}
                    action={{ iconName: 'Calculator', controller: onOpenCalculatorDialog }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
            </div>{
                calculatorDialogOpen &&
                <CalculatorDialog
                    {...rest}
                    open={calculatorDialogOpen}
                    onClose={onCloseCalculatorDialog}
                    onOk={handleOk}
                    initialValues={initialValues}
                    valuesSchema={valuesSchema}
                    formSchema={formSchema}
                    summaryTableSchema={summaryTableSchema}
                    onCalculate={onCalculate}
                    summaryTableData={summaryTableData}
                    isCalculateDisabled={isCalculateDisabled}
                    dialogTitle={dialogTitle}
                    dialogStyles={dialogStyles}
                />
            }
        </>
    );
};

export default withStyles(styles)(CalculatorField);
